import Vue from "vue"
import Router from "vue-router"

Vue.use(Router)

import routes from "./routes"

const router = new Router({
	mode: "history",
	base: process.env.BASE_URL,
	routes,
})

router.beforeEach((to, from, next) => {
	const nearestWithTitle = to.matched
		.slice()
		.reverse()
		.find((x) => x.meta && x.meta.title)

	if (nearestWithTitle) {
		document.title = nearestWithTitle.meta.title
	}

	const nearestWithMetaTags = to.matched
		.slice()
		.reverse()
		.find((x) => x.meta && x.meta.tags && x.meta.tags.length)

	Array.from(document.querySelectorAll("[data-vue-router-controlled]")).forEach((el) => {
		el.parentNode.removeChild(el)
	})

	if (nearestWithMetaTags) {
		nearestWithMetaTags.meta.tags.forEach((tag) => {
			let el = document.createElement("meta")

			Object.keys(tag).forEach((key) => {
				el.setAttribute(key, tag[key])
			})

			el.setAttribute("data-vue-router-controlled", "")

			document.head.appendChild(el)
		})
	}

	next()
})

export default router
